<template>
  <div class="pb-4">
    <render-category v-model="categoryId" />

    <v-card
      v-if="categoryId !== 0"
      :loading="loadingTableData"
      class="m-5 p-5 shadow-none"
    >
      <v-card-title class="align-center">
        <v-btn
          :loading="loadingTableData"
          class="btn-accept ma-0"
          @click="getProducts()"
        >
          دریافت محصولات
        </v-btn>
        <v-spacer />

        <span>تعداد کل: {{ totalProducts }}</span>
        <span class="mx-2 font-size-h1 grey--text">|</span>
        <v-btn
          :loading="getTotalProductLoading"
          class="btn-accept ma-0"
          @click="getProductsCount"
        >
          دریافت تعداد محصولات
        </v-btn>
      </v-card-title>

      <v-divider />

      <vue-table :data="data" :headers="headers" @change="onPagination">
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="1" md="2">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="4" md="6">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو"
                outlined
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
        </template>

        <template v-slot:image="{ item }">
          <v-avatar class="ma-1 rounded-lg" size="52">
            <v-img
              v-if="
                !!item.data.gallery &&
                !!item.data.gallery[0] &&
                !!item.data.gallery[0].images &&
                !!item.data.gallery[0].images[0] &&
                !!item.data.gallery[0].images[0].url
              "
              :src="item.data.gallery[0].images[0].url"
            />
          </v-avatar>
        </template>

        <template v-slot:manage="{ item }">
          <manage-button :data="item" :meta="metaButtons" />
        </template>
      </vue-table>
    </v-card>

    <product-editor
      v-if="categoryId !== 0 && computedProduct"
      v-model="computedProduct"
      :has-return="false"
      :newData="selectedProductId"
      @input="saveNewProduct"
    />
  </div>
</template>

<script>
import ProductEditor from "@/view/components/Product/ProductEditor.vue";
import CategoryList from "@/view/components/Category/categoryList.vue";
import RenderCategory from "@/view/components/Category/renderCategory.vue";
import MixedTable from "@/view/components/Table/MixedTable.vue";
import manageButton from "@/view/pages/button.vue";

export default {
  name: "BlogTemplate",

  components: {
    MixedTable,
    RenderCategory,
    CategoryList,
    ProductEditor,
    manageButton,
  },

  data() {
    return {
      computedProduct: undefined,
      categoryId: 0,
      totalProducts: 0,
      getTotalProductLoading: false,
      data: {},
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" },
        { value: "image", text: "تصویر", sortable: false, align: "center" },
        { value: "title", text: "عنوان", sortable: false, align: "center" },
        { value: "manage", text: "مدیریت", sortable: false, align: "center" },
      ],
      metaButtons: {
        buttons: [
          {
            name: "selectProduct",
            label: "تاریخچه کیف پول",
            icon: "edit",
            class: "btn-outline-primary",
            action: this.action,
          },
          {
            name: "deleteProduct",
            label: "حذف",
            icon: "trash",
            class: "btn-outline-danger",
            action: this.action,
          },
        ],
      },
      tableProps: {
        page: 1,
        length: 10,
        search: "",
      },
      loadingTableData: false,
      selectedProduct: undefined,
    };
  },

  computed: {
    selectedProductId() {
      return this.selectedProduct?.id || 0;
    },
  },

  methods: {
    saveNewProduct(obj) {
      if (this.selectedProduct)
        this.$api
          .put("/template/" + this.selectedProduct.id, {
            title: obj.title,
            data: obj,
            category_id: this.selectedProduct.category_id,
          })
          .then(() => {
            this.$toast.success("محصول با موفقیت ویرایش شد");
            this.selectedProduct = undefined;
            this.computedProduct = undefined;
            this.getProducts();
          })
          .catch(() => {
            this.$toast.error("خطا در ویرایش محصول");
          });
      else
        this.$api
          .post("/template", {
            title: obj.title,
            data: obj,
            category_id: this.categoryId,
          })
          .then(() => {
            this.$toast.success("محصول با موفقیت اضافه شد");
            this.getProducts();
          })
          .catch(() => {
            this.$toast.error("خطا در اضافه کردن محصول");
          });
    },
    getProducts(params = this.tableProps) {
      this.loadingTableData = true;

      this.$api
        .get("/template", {
          params: {
            category: this.categoryId,
            ...params,
          },
        })
        .then(({ data }) => {
          this.data = data.data;
          this.totalProducts = data.data.total;
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || "خطا در دریافت لیست محصولات!",
          );
        })
        .finally(() => (this.loadingTableData = false));
    },
    getProductsCount() {
      this.getTotalProductLoading = true;

      this.$api
        .get("/template", {
          params: {
            category: this.categoryId,
            getCount: true,
          },
        })
        .then(({ data }) => {
          this.totalProducts = data.data;
        })
        .finally(() => (this.getTotalProductLoading = false));
    },
    deleteProduct(id) {
      this.$modal
        .yesNo("تایید حذف!", "آیا از حذف محصول موردنظر اظمینان دارید؟")
        .then((value) => {
          if (value) {
            this.loadingTableData = true;

            this.$api
              .delete("/template/" + id)
              .then((res) => {
                this.getProducts();
              })
              .catch(() => ({}))
              .finally(() => {
                this.loadingTableData = false;
              });
          }
        });
    },
    onPagination(e) {
       this.tableProps = {
    ...this.tableProps,
    ...e,
  };
      this.getProducts(this.tableProps);
    },
    action(data, type) {
      switch (type) {
        case "selectProduct":
          this.selectedProduct = data;
          this.computedProduct = data.data;
          break;
        case "deleteProduct":
          this.deleteProduct(data.id);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped></style>
